@if (selected()) {
  <span class="tenant-status-icon tenant-status-icon--selected" aria-hidden="true">✓</span>
}
@else {
  <span class="tenant-status-icon" aria-hidden="true"></span>
}
